var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_10034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 40.2C30.1127 40.2 37.5 32.8127 37.5 23.7C37.5 14.5873 30.1127 7.2 21 7.2C11.8873 7.2 4.5 14.5873 4.5 23.7C4.5 32.8127 11.8873 40.2 21 40.2Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 8.7C29.27 8.7 36 15.43 36 23.7C36 31.97 29.27 38.7 21 38.7C12.73 38.7 6 31.97 6 23.7C6 15.43 12.73 8.7 21 8.7ZM21 5.7C11.06 5.7 3 13.76 3 23.7C3 33.64 11.06 41.7 21 41.7C30.94 41.7 39 33.64 39 23.7C39 13.76 30.94 5.7 21 5.7Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0006 25.56C22.0279 25.56 22.8606 24.7272 22.8606 23.7C22.8606 22.6727 22.0279 21.84 21.0006 21.84C19.9734 21.84 19.1406 22.6727 19.1406 23.7C19.1406 24.7272 19.9734 25.56 21.0006 25.56Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6201 1H15.3701V4H26.6201V1Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1895 5.95V3.5L19.1895 3.5V5.95H23.1895Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6 18.87C30.71 14.33 26.23 11.14 21 11.14V23.7L32.6 18.87Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_10034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimer);
export default __webpack_public_path__ + "static/media/icon_timer.f9677a70cd03425b04c1d1e12c5e5520.svg";
export { ForwardRef as ReactComponent };